module.exports = __webpack_public_path__ + "img/rooms.1b610585.svg";